import { Capabilities, PlatformType } from "@spawn/common";
import {
	IAssetHandle,
	Orientation,
	ScreenOrientationService,
	Sprite,
	TextureResource,
	View,
	ViewFixedSize,
	asset,
	inject,
	subscription,
	view,
} from "@spawn/core";
import { FreegameService } from "@spawn/freegames";
import { Subscription } from "rxjs";
import Victor from "victor";
import { Layout } from "@spawn/nrg-games-core";

@view
export class ReelSetFrameView extends ViewFixedSize {
	@asset(TextureResource) public readonly bgFrameTexture!: IAssetHandle<TextureResource>;
	@asset(TextureResource) public readonly bgLogoTexture!: IAssetHandle<TextureResource>;
	@asset(TextureResource) public readonly fgFrameTexture!: IAssetHandle<TextureResource>;
	@asset(TextureResource) public readonly fgLogoTexture!: IAssetHandle<TextureResource>;

	@inject private readonly fgService!: FreegameService;
	@inject private readonly orientationService!: ScreenOrientationService;

	@subscription protected subscriptions = new Set<Subscription>();

	private bgFrame!: Sprite;
	private bgLogo!: Sprite;
	private fgFrame!: Sprite;
	private fgLogo!: Sprite;
	private logoView!: View;

	constructor() {
		super({
			layout: Layout.center(),
			size: new Victor(1559, 971), // height = frame+logo
		});
		this.createReelSetFrame();
		this.setLogoView();
		this.position = this.position.clone().subtractScalarY(65);

		this.subscriptions.add(this.orientationService.orientationChanged$.subscribe(() => this.onOrientationChange()));
	}

	protected createReelSetFrame(): void {
		this.bgFrame = new Sprite(this.bgFrameTexture(), Layout.bottom());
		this.bgLogo = new Sprite(this.bgLogoTexture(), Layout.top());
		this.addChild(this.bgFrame, this.bgLogo);
		this.fgFrame = new Sprite(this.fgFrameTexture(), Layout.bottom());
		this.fgLogo = new Sprite(this.fgLogoTexture(), Layout.top());
		this.addChild(this.fgFrame, this.fgLogo);

		// eslint-disable-next-line
		this.fgService.isActive$.subscribe((isActive) => {
			this.fgFrame.visible = isActive;
			this.fgLogo.visible = isActive;
		});
	}

	public setLogoView(): void {
		this.logoView = new View({
			layout: Layout.top(),
		});
		this.logoView.visible = this.bgLogo.visible || this.fgLogo.visible;
		this.logoView.addChild(this.bgLogo, this.fgLogo);
		this.addChild(this.logoView);
	}

	private onOrientationChange(): void {
		if (
			Capabilities.platformType === PlatformType.Desktop ||
			(Capabilities.platformType === PlatformType.Mobile && this.orientationService.orientation === Orientation.Portrait)
		) {
			this.logoView.visible = true;
		} else {
			this.logoView.visible = false;
		}
	}
}
